module.exports = __webpack_public_path__ + "img/grid_map_default.36ecbde0.svg";